// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f7760ffa","667":"2b7ffce4","977":"b9710d43"}[chunkId] + ".chunk.js";
};